/* eslint-disable */
<template>
	<!--<div class="perfect">-->

	<!--<transition name="el-fade-in-linear">-->
	<!--<div v-show="informationShow">-->
	<!--<div class="datahint error-me-tlt" v-html="datahint">
				</div>-->

	<el-tabs v-model="activeName" type="">
		<el-tab-pane label="用户管理" name="first">
			<!--<div class="f-cb">-->
			<div class="formbox f-cb">
				<p class="error-me-tlt">组织/单位资料支持修改部分信息，请务必填写真实信息，方便我们能及时联系到您！</p>
				<el-form ref="form" :model="form" label-width="170px" :rules="rules" :disabled='blockform'>
					<div class="f-fl context-fl">
						<div v-if="  $store.state.userSet ">

							<el-form-item label="用户名称：" prop="registerName">
								<el-input v-model.trim="form.registerName" type="text" style="width:80%"></el-input>
							</el-form-item>
							<el-form-item label="密码：" prop="userPassword">
								<el-input v-model.trim="form.userPassword" type="password" style="width:80%"></el-input>
							</el-form-item>
							<el-form-item label="确认密码：" prop="userPasswordTwo">
								<el-input v-model.trim="form.userPasswordTwo" type="password" style="width:80%"></el-input>
							</el-form-item>
						</div>
						<el-form-item label="组织/单位名称：" prop="name">
							<el-input v-model="form.name" type="text" style="width: 50%;" :disabled="namedisabled">
							</el-input>
						</el-form-item>

						<el-form-item label="组织/单位注册所在地域：" prop="site">
							<span v-if="form.territory!=''">{{form.territory}}</span>

							<div class="size f-cb" v-else>
								<el-select v-model="form.site.province.value" placeholder="请选择省份" style="float: left;width:30%" @visible-change="province" @change="provinceVal">
									<el-option v-for="item in form.site.province.data" :key="item.value" :label="item.label" :value="item.value">
									</el-option>
								</el-select>
								<el-select v-model="form.site.city.value" placeholder="请选择市" style="float: left;width: 28%; margin-left: 10px;" @change="city" no-data-text="请先选择上一级">
									<el-option v-for="item in form.site.city.data" :key="item.value" :label="item.label" :value="item.value">
									</el-option>
								</el-select>
								<el-select v-model="form.site.district.value" placeholder="请选择区" style="float: left;width:28%; margin-left: 10px;" no-data-text="暂无数据">
									<el-option v-for="item in form.site.district.data" :key="item.value" :label="item.label" :value="item.value">
									</el-option>
								</el-select>
							</div>

						</el-form-item>
						<el-form-item label="组织/单位性质：" prop="nature">
							<el-select v-model="form.nature" placeholder="请选择组织/单位性质">
								<el-option v-for="(item,index) in form.naturedata" :label="item.label" :key="index" :value="item.value"></el-option>
							</el-select>

						</el-form-item>
						<el-form-item label="组织/单位行业：" prop="industry">
							<p class="f-cb">
								<el-select v-model="form.industry.stair.present" placeholder="请选择" class="f-fl" style="width: 48%;" @change="IndustryGroup">
									<el-option v-for="(item,index) in form.industry.stair.data" :label="item.label" :key="index" :value="item.value"></el-option>

								</el-select>
								<el-select v-model="form.industry.secondlevel.present" placeholder="请选择" class="f-fr" style="width: 48%;">
									<el-option v-for="(item,index) in form.industry.secondlevel.data" :label="item.label" :key="index" :value="item.value"></el-option>

								</el-select>
							</p>
						</el-form-item>
						<el-form-item label="组织/单位地址：" prop="desc">
							<el-input v-model="form.desc" placeholder="请填写组织/单位详细地址"></el-input>
						</el-form-item>
						<el-form-item label="安全邮箱：" prop="mailbox">
							<el-input v-model="form.mailbox" placeholder=""></el-input>
						</el-form-item>
						<el-form-item label="成为SP服务商：" prop="intention" v-show="false">
							<el-radio-group v-model="form.intention">
								<el-radio :label="1">有意向</el-radio>
								<el-radio :label="0">无意向</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="联系人：" prop="linkman">
							<el-input v-model="form.linkman" placeholder=""></el-input>
						</el-form-item>

						<el-form-item label="联系电话：" prop="phone">
							<el-input v-model.trim="form.phone" placeholder="请填写联系电话"></el-input>
						</el-form-item>

						<el-form-item label="联系人手机：" prop="mobile">
							<el-input v-model.trim="form.mobile" placeholder="请填写联系人手机"></el-input>
						</el-form-item>

						<el-form-item label="证件类型：" prop="idtype">
							<el-select v-model="form.idtype.present" placeholder="请选择">
								<el-option v-for="(item,index) in form.idtype.data" :label="item.label" :key="index" :value="item.value"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="统一社会信用代码：" prop="Unifiedsocialcredit" v-if="form.idtype.present === 2">
							<el-input v-model.trim="form.Unifiedsocialcredit" placeholder="请填写统一社会信用代码"></el-input>
						</el-form-item>
						<el-form-item label="证件号：" prop="Unifiedsocialcredit" v-else>
							<el-input v-model.trim="form.Unifiedsocialcredit" placeholder="请填写证件号"></el-input>
						</el-form-item>

						<el-form-item>
							<el-button type="primary" @click="onSubmit('form')">保存修改</el-button>
						</el-form-item>
					</div>
					<div class="f-fr">
						<el-form-item prop="imageUrl">
							<p solt="label" style="text-align: left;color: #606266;" class="custom-label">组织/单位营业执照： </p>
							<div class="avatar-uploader">
								<!--{{webimgurl.imageUrl + webimgurl.imageBig}}-->
								<div class="el-upload">
									<img v-if="form.imageUrl" :src="'/UploadImages/'+form.imageUrl.split('|')[1]" class="avatar" @click="amplificationImg(form.imageUrl.split('|')[0])">
									<i v-else class="el-icon-plus avatar-uploader-icon"></i>
								</div>
							</div>
							<file-upload ref="upload" v-model="files" input-id="files" :post-action="$api+'/upload/uploadImage'" accept="image/png,image/gif,image/jpeg,image/webp" @input-file=" inog" input-filter="inputFilter" extensions="jpg,gif,png,webp" :size="1024 * 1024*5" @input="updatetValue">
								<el-button type="primary" style="margin-left: 70px;">上传</el-button>
							</file-upload>

							<div class="el-upload__tip">请上传组织/单位营业执照，小于5M</div>
						</el-form-item>
						<el-form-item prop="logoUrl">
							<p solt="label" style="text-align: left;color: #606266; ">组织/单位Logo： </p>
							<div class="avatar-uploader">
								<div class="el-upload">
									<img v-if="form.logoUrl" :src="'/UploadImages/'+ form.logoUrl.split('|')[1]" class="avatar">
									<i v-else class="el-icon-plus avatar-uploader-icon"></i>
								</div>

							</div>

							<file-upload ref="yang" v-model="filestwo" :post-action="$api+'/upload/uploadImage'" accept="image/png,image/gif,image/jpeg,image/webp" @input-file="inputFilelog" input-id="filestwo" extensions="jpg,gif,png,webp" :size="1024 * 1024*5" @input-filter="inputFilter" @input="updateteo">
								<el-button type="primary" style="margin-left: 70px;">logo上传</el-button>
							</file-upload>

							<div class="el-upload__tip">请上传企业Logo，建议尺寸：280*210，小于5M</div>

						</el-form-item>

					</div>

				</el-form>

				<div></div>
			</div>

		</el-tab-pane>
		<el-tab-pane label="拓展资料" name="second">
			<div class="extend">

				<el-form ref="expandform" :model="expandform" label-width="200px " :disabled='blockform' :rules="exrules">
					<el-form-item label="组织/单位名称：">
						<el-input v-model="form.name" type="text" style="width: 50%;" :disabled="namedisabled">
						</el-input>
					</el-form-item>
					<el-form-item label="组织/单位英文名称： 	">
						<el-input v-model="expandform.Englishname"></el-input>
					</el-form-item>
					<el-form-item label=" 组织/单位英文注册地址：">
						<el-input v-model="expandform.Englishaddress"></el-input>
					</el-form-item>
					<el-form-item label="组织/单位办公地址：">
						<el-input v-model="expandform.businessaddress"></el-input>
					</el-form-item>

					<el-form-item label="组织/单位英文办公地址：">
						<el-input v-model="expandform.Englishbusinessaddress"></el-input>
					</el-form-item>

					<el-form-item label="组织/单位解析地址：">
						<el-input v-model="expandform.ParsingTheAddress"></el-input>
					</el-form-item>

					<el-form-item label="组织/单位规模： 	">
						<el-select v-model="expandform.scale" placeholder="请选择组织/单位规模">
							<el-option v-for="(item,index) in scaleData" :label="item.label" :key="index" :value="item.value"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="组织/单位注册资金：" prop="registered">
						<el-input v-model="expandform.registered" style="width: 90%;"></el-input><span style="margin-left: 5px;">万元</span>
					</el-form-item>

					<el-form-item>
						<el-button type="primary" @click="onSubmit('form')">保存修改</el-button>
					</el-form-item>
				</el-form>

			</div>

		</el-tab-pane>
	</el-tabs>
	<!--</transition>-->
	<!--</div>-->
</template>

<script>
	//	import FileUpload from 'vue-upload-component'

	export default {
		name: 'perfect',

		props: {
			brand: {
				default: '名称'
			}
		},
		data() {
			var sitePass = (rule, value, callback) => {

				if(this.form.territory != '') {
					callback();
				} else {
					if(value.province.value === '') {
						callback(new Error('请输入地址'));

					} else {

						if(this.form.resource == 'province' && value.province.value == "") {
							//          this.$refs.ruleForm.validateField('sitef');
							callback(new Error('请输入省份'));
						} else if(this.form.resource == 'city' && value.province.value == "" && value.city.value == "") {
							callback(new Error('请输入省份和市'));

						}

						callback();
					}
				}

			};

			var industryPass = (rule, value, callback) => {
				if(value.stair.present === '' && value.secondlevel.present === '') {
					callback(new Error('请输入组织/单位行业'));

				} else {

					callback();
				}
			};
			var idtypePass = (rule, value, callback) => {
				//				console.log(value.present)
				if(value.present === '') {
					callback(new Error('请选择证件类型'));

				} else {
					callback();
				}
			};
			var onePass = (rule, value, callback) => {
				if(this.form.phone != '' || this.form.mobile != '') {
					callback();
				} else {
					//					callback();
					callback(new Error('联系电话和手机号码至少填写一个'));
				}
			};
			var validatePass = (rule, value, callback) => {
				//				console.log(value)
				if(value === '') {
					callback(new Error('请输入密码'));
				} else {
					if(this.form.checkPass !== '') {
						this.$refs.form.validateField('checkPass');
					}
					callback();
				}
			};
			var validatePass2 = (rule, value, callback) => {
				if(value === '') {
					callback(new Error('请再次输入密码'));
				} else if(value !== this.form.userPassword) {
					callback(new Error('两次输入密码不一致，请重新输入!'));
				} else {
					callback();
				}
			};

			var registerNamePass = (rule, value, callback) => {
				this.$http.get(this.$api + '/organUnit/validateLoginName', {
					params: {
						loginName: value
					}
				}).then(res => {
					if(res.body.result === 0) {
						callback(new Error(res.body.message));

					} else {
						callback();

					}
				})
			}

			var numberVerification = (rule, value, callback) => {
				if(this.form.idtype.present === '') {
					callback(new Error('请先选择证件类型'));

				} else {
					if(!value) {
						callback(new Error('请填写证件号码'));

					} else {

						if(this.form.idtype.present == 2) {
							if(!/^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g.test(value)) {

								callback(new Error('统一社会信用代码格式不正确，请重新填写'));

							} else {

								callback();

							}
						} else {
							callback();

						}

					}
				}

			}
			var entamine = (rule, value, callback) => {
				console.log(!this.namedisabled)
				if(value === '') {
					callback(new Error('请填写组织/单位名称'));
					this.safetyVerify = false;

				} else {
					if(value.length <= 2 || value.length > 48) {
						callback(new Error('必须大于2小于46'));
						this.safetyVerify = false;

					} else if(!this.namedisabled) {

						this.$http.get(this.$api + '/organUnit/validateUnitName', {
							params: {
								organUnitName: value,
								organUnitID: this.$store.state.commonalityData.IdcodeUserId || 0
							}
						}).then(res => {
							if(res.body.result === 0) {
								////					    console.log(this.searchingShow,'3')
								//				console.log(this.namedisabled)				
								//								if(this.namedisabled) {
								//									callback(new Error('您输入的企业名称已在IDcode平台注册，请在下面输入用户名和密码进行安全校验'));
								////namedisabled
								//								} else {
								callback(new Error(res.body.message));
								//								}		
								this.safetyVerify = true;
							} else {
								this.safetyVerify = false;
								callback();
							}

						})

					} else {
						callback();

					}
				}
			};
			return {
				files: [],
				filestwo: [],
				userDataShow: false,
				datahint: '',
				migrationid: '',
				informationShow: false,
				blockform: false,
				namedisabled: false,
				form: {
					id: '',
					name: '',
					territory: '',
					nature: '',
					certificate: '',
					naturedata: [],
					site: {
						province: {
							value: '',
							data: '',
						},
						city: {
							value: '',
							data: '',
						},
						district: {
							value: '',
							data: '',
						},
					},
					industry: {
						stair: {
							present: '',
							data: []
						},
						secondlevel: {
							present: '',
							data: []
						},

					},

					date2: '',
					delivery: false,
					type: [],
					linkman: '',
					phone: '',
					mobile: '',
					idtype: {
						present: '',
						data: [{
								value: 0,
								label: '其他'
							},
							{
								value: 2,
								label: '统一社会信用代码'
							}
						]

					},
					mailbox: '',
					intention: 0,
					resource: '',
					desc: '',
					Unifiedsocialcredit: '',
					imageUrl: '',
					logoUrl: '',
					registerName: '',
					userPassword: '',
					userPasswordTwo: ''
				},
				magnify: {
					imageUrl: '',
					logoUrl: '',
				},
				webimgurl: {},
				webimgur2: {},

				inquires: {
					parentID: 0,
					level: 1
				},
				name: '',
				activeName: 'first',
				rules: {

					registerName: [{
							required: true,
							message: '请输入登录用户名称',
							trigger: 'blur'
						},
						{
							validator: registerNamePass,
							trigger: 'change'

						}

					],
					userPassword: [

						{
							required: true,
							validator: validatePass,
							trigger: 'blur'
						},
						{
							pattern: /^[A-Za-z0-9_]+$/,
							message: '请输入6至20位的英文字母、数字或两者组合！',
							trigger: 'blur'
						},
						{
							min: 6,
							max: 20,
							message: '请输入6至20位的密码',
							trigger: 'blur'
						}
					],

					userPasswordTwo: [{
							required: true,
							validator: validatePass2,
							trigger: 'blur'
						},
						{
							pattern: /^[A-Za-z0-9_]+$/,
							message: '请输入6至20位的英文字母、数字或两者组合！',
							trigger: 'blur'
						}
					],
					name: [{
						validator: entamine,
						trigger: 'blur'
					}, ],

					site: [{
							validator: sitePass,
							trigger: 'blur'
						}

					],
					nature: [{
						required: true,
						message: '请选择组织/单位性质',
						trigger: 'blur'
					}],
					industry: [{
						required: true,

						validator: industryPass,
						trigger: 'blur'
					}],
					desc: [{
						required: true,
						message: '请填写组织/单位地址',
						trigger: 'blur'
					}],
					mailbox: [{
							required: true,
							message: '请填写邮箱',
							trigger: 'blur'
						},
						{
							pattern: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/,
							message: '邮箱格式不正确，请检查',
							trigger: 'blur'
						}
					],
					intention: [{
						required: true,
						message: '您是否有意向',
						trigger: 'blur'
					}],
					linkman: [{
						required: true,
						message: '请填写联系人',
						trigger: 'blur'
					}],
					phone: [{
						validator: onePass,
						trigger: 'blur'
					}, ],
					certificate: [

						{
							required: true,
							message: '请填写证件号',
							trigger: 'blur'
						}
					],
					mobile: [{
						pattern: /^((13|14|15|17|18|19)[0-9]{1}\d{8})$/,
						message: '电话号格式不正确，请检查',
						trigger: 'blur'
					}, ],
					idtype: [{
						validator: idtypePass,
						trigger: 'blur'
					}],
					Unifiedsocialcredit: [{
							required: true,

							validator: numberVerification,
							trigger: 'blur'
						}

					],
					imageUrl: [{
						required: true,
						message: '请上传组织/单位营业执照',
						trigger: 'blur'
					}],
					logoUrl: [],
				},
				expandform: {
					name: '',
					Englishname: '',
					Englishaddress: '',
					businessaddress: '',
					Englishbusinessaddress: '',
					ParsingTheAddress: '',
					scale: '',
					registered: ''
				},
				exrules: {
					registered: [{
						pattern: /^[0-9_]+$/,
						message: '格式不正确，请填写数字类型',
						trigger: 'blur'
					}]
				},
				scaleData: [],

			}

		},
		created() {

			if(this.$store.state.commonalityData.IdcodeUserId) {
				this.homecourt2();
				this.$http.get(this.$api + '/organUnit/getUnitInfoByID', {
					params: {
						unitID: this.$store.state.commonalityData.IdcodeUserId
					}
				}).then(res => {

					this.datafill(res);
				})
			} else {
				this.homecourt();
				//				console.log(this.searchingShow,'2')

			}

			this.userDataShow = false;
		},
		mounted() {
			//			单位性质基础数据
			this.$http.get(this.$api + '/baseData/getUnitTypeList', {}).then(res => {
				this.form.naturedata = res.body.entity.map((item, index) => {
					return {
						value: item.code,
						label: item.unittypename
					}
				})
			})
			//			行业基础数据
			this.industryData({
				id: 0
			}).then(res => {
				this.form.industry.stair.data = res.body.entity.map((item, index) => {
					return {
						value: item.tradeId,
						label: item.tradename
					}
				})
			})
			this.scaledata();

		},
		watch: {
			brand: function(val) {
				this.form.name = this.brand
			}
		},
		methods: {
			inog(newFile, oldFile) {
				if(newFile && oldFile && !newFile.active && oldFile.active) {
					if(newFile.xhr) {
						//  获得响应状态码
						console.log('status', newFile.xhr.status)
						let res = JSON.parse(newFile.xhr.response)

						if(res.result == 1) {
							if(res.entity != undefined) {
								this.form.imageUrl = res.entity.imageBig + '|' + res.entity.imageSmall;
							}
						} else {
							this.$message({
								showClose: true,
								message: res.message,
								duration: '1000',
								type: 'error'
							});
						}
					} else if(newFile.iframe) {
						if(newFile.response.entity) {
							let res = newFile.response

							if(res.result == 1) {
								this.form.imageUrl = res.entity.imageBig + '|' + res.entity.imageSmall;

							} else {
								this.$message({
									showClose: true,
									message: res.message,
									duration: '1000',
									type: 'error'
								});
							}
						}
					}
				}
			},
			inputFilelog(newFile, oldFile) {
				if(newFile && oldFile && !newFile.active && oldFile.active) {

					if(newFile.xhr) {
						// 获得响应状态码
						let res = JSON.parse(newFile.xhr.response)

						if(res.result == 1) {
							if(res.entity != undefined) {
								this.form.logoUrl = res.entity.imageBig + '|' + res.entity.imageSmall;
							}
						} else {
							this.$message({
								showClose: true,
								message: res.message,
								duration: '1000',
								type: 'error'
							});
						}
					} else if(newFile.iframe) {
						if(newFile.response.entity) {
							let res = newFile.response

							if(res.result == 1) {
								this.form.logoUrl = res.entity.imageBig + '|' + res.entity.imageSmall;

							} else {
								this.$message({
									showClose: true,
									message: res.message,
									duration: '1000',
									type: 'error'
								});
							}
						}
					}
				}
			},
			inputFilter: function(newFile, oldFile, prevent) {
				if(newFile && !oldFile) {
					// 过滤不是图片后缀的文件
					//					jpg.png.gif.jpeg.bmp
					if(!/\.(jpeg|jpe|jpg|gif|png|webp|bmp)$/i.test(newFile.name)) {
						this.$message.error('仅支持jpg.png.gif.jpeg.bmp后缀图片上传');
						return prevent()
					}
				}

				// 创建 blob 字段 用于图片预览
				newFile.blob = ''
				let URL = window.URL || window.webkitURL
				if(URL && URL.createObjectURL) {
					newFile.blob = URL.createObjectURL(newFile.file)
				}
			},
			updatetValue(value) {
				this.$refs.upload.active = true;

			},
			updateteo() {
				this.$refs.yang.active = true;

			},
			onSubmit(formName) {
				let registeredNuber;
				this.$refs.expandform.validateField('registered', (error) => {
					if(!error) {
						registeredNuber = true;
					} else {
						registeredNuber = false;
					}
				})
				this.$refs[formName].validate((valid) => {
					if(valid && registeredNuber) {
						let {
							form,
							expandform
						} = this;
						this.$http.post(this.$api + '/organUnit/saveUnitInfo', {
							organunit_id: form.id || 0,
							organunitname: this.form.name,
							organunitnameen: expandform.Englishname,
							province_id: this.form.site.province.value,
							city_id: this.form.site.city.value,
							area_id: this.form.site.district.value,
							unittypedisplay_id: this.form.nature,
							trade_id: this.form.industry.secondlevel.present,
							organunitaddress: form.desc,
							organunitaddressen: expandform.Englishaddress,
							unitworkaddress: expandform.businessaddress,
							unitworkaddressen: expandform.Englishbusinessaddress,
							email: form.mailbox,
							organunitlevel: this.form.intention,
							linkman: form.linkman,
							fax: form.phone,
							linkphone: form.mobile,
							codepaytype: form.idtype.present,
							organizationcode: form.Unifiedsocialcredit,
							organunitlicense: form.imageUrl,

							//							this.webimgurl.imageBig===undefined?'': this.webimgurl.imageBig + '|' + this.webimgurl.imageSmall,
							uniticon: form.logoUrl,
							//							this.webimgur2.imageBig === undefined?'':  this.webimgur2.imageBig + '|' + this.webimgur2.imageSmall,
							gotourl: expandform.ParsingTheAddress,
							unitsizetype_id: expandform.scale || 3,
							registeredcapital: expandform.registered || -1,
							loginName: form.registerName, //用户名
							loginPwd: form.userPasswordTwo, //用户名							

						}).then(res => {
							if(res.body.result === 1) {
								this.$message({
									message: '提交修改成功',
									type: 'success',
									duration: '900',
									
								});
								//store,cookie更新	
								this.$store.dispatch('DataUpdate', res.body.entity).then(res => {
									this.$setCookie('Data', escape(JSON.stringify(res)));
								})

								setTimeout(() => {
									this.$router.push('/')
								}, 1000)

							} else {
								this.$message.error(res.body.message + '请尝试重新提交');
							}
						}, res => {
							this.$message.error('提交错误，请尝试重新提交');

						})

					} else {
						return false;
					}
				});

			},
			handleAvatarSuccess(res, file) {
				if(res.result === 1) {
					this.form.imageUrl = res.entity.imageBig + '|' + res.entity.imageSmall;
					this.webimgurl = res.entity;
				}
			},
			logoSuccess(res, file) {
				if(res.result === 1) {
					let {
						form
					} = this;
					this.form.logoUrl = res.entity.imageBig + '|' + res.entity.imageSmall;
					this.webimgur2 = res.entity;
				}
			},
			exist(value) {
				this.$http.get(this.$api + '/organUnit/validateUnitName', {
					params: {
						organUnitName: this.searchingform.name,
						organUnitID: 0
					}
				}).then(res => {
					//					if(res.body.result === 0) {
					//						console.log(res.body.message)
					//					}
					this.errorContext = res.body.message
				})

			},
			//			appear({
			//				name,
			//				account,
			//				password
			//			}) {
			//				this.$http.get(this.$api + '/organUnit/getUnitInfoByName', {
			//					params: {
			//						organUnitName: this.searchingform.name || name,
			//						loginName: this.searchingform.account || account,
			//						loginPwd: this.searchingform.password || password
			//					}
			//				}).then(res => {
			//					this.datafill(res);
			//				})
			//
			//			},

			datafill(res) {
				if(res.body.result === 1) {
					this.homecourt2();
					let {
						form,
						expandform
					} = this;
					let {
						organUnit,
						organUnitArea,
						trade_parent_id,
						organUnitTrade,
						isDisabled,
						unitNameIsEdit,
						selectNature,
						messageTip
					} = res.body.entity;
					//						权限控制
					this.blockform = isDisabled === 0 ? false : true;
					this.namedisabled = unitNameIsEdit === 0 ? false : true;
					//                   基础数据
					if(trade_parent_id != -100) {
						this.industryData({
							id: trade_parent_id
						}).then(res => {
							this.form.industry.secondlevel.data = res.body.entity.map((item, index) => {
								return {
									value: item.tradeId,
									label: item.tradename
								}
							})
						})
					}

					//						赋值
console.log(organUnit)
					form.name = organUnit.organunitname;
					form.id = String(organUnit.organunit_id_str);
					form.intention = organUnit.organunitlevel;
					form.mailbox = organUnit.email;
					form.desc = organUnit.organunitaddress;
					form.linkman = organUnit.linkman //联系人
					form.phone = organUnit.fax //联系电话
					form.industry.stair.present = trade_parent_id === -100 ? '' : trade_parent_id;

					form.industry.secondlevel.present = organUnit.trade_id === -100 ? '' : organUnit.trade_id;
					//					this.datahint = messageTip;
					this.$emit('post', messageTip === null ? '' : messageTip)
					expandform.Englishname = organUnit.organunitnameen;

					expandform.Englishaddress = organUnit.organunitaddressen;
					expandform.businessaddress = organUnit.unitworkaddress;
					expandform.Englishbusinessaddress = organUnit.organunitaddressen;
					expandform.ParsingTheAddress = organUnit.gotourl; //单位解析地址
					expandform.scale = organUnit.unitsizetype_id; //单位规模
					expandform.registered = organUnit.registeredcapital < 0 ? 0 : organUnit.registeredcapital;
					//单位注册资金
					form.mobile = organUnit.linkphone //联系人手机
					form.idtype.present = organUnit.codepaytype //证件类型
					form.Unifiedsocialcredit = organUnit.organizationcode //证件号码
					form.imageUrl = organUnit.organunitlicense //营业执照
					form.logoUrl = organUnit.uniticon === null ? '' : organUnit.uniticon //单位Logo
					form.territory = organUnitArea;
					this.form.nature = selectNature;
				} else {
					this.$message.error(res.body.message);
					this.searchingform.password = '';
					this.$refs.sform.validateField('password');

				}
			},
			industryData({
				id
			}) {
				return this.$http.get(this.$api + '/baseData/getTradeList', {
					params: {
						parentID: id
					}
				})
			},
			IndustryGroup(id) {
				this.industryData({
					id: id
				}).then(res => {

					this.form.industry.secondlevel.data = res.body.entity.map((item, index) => {
						return {
							value: item.tradeId,
							label: item.tradename
						}
					})
					this.form.industry.secondlevel.present = this.form.industry.secondlevel.data[0].value;
				})

			},
			//地址通用请求
			locationdata() {
				let a = this.$http.get(this.$api + '/baseData/getAddressList', {
					params: this.inquires
				});
				return a;
			},
			//省
			province() {
				let province = this.form.site.province.data;
				if(province) {
					return;
				} else {
					this.locationdata().then(function(res) {
						if(res.data != "") {
							this.form.site.province.data = res.body.entity.map(function(item) {
								return {
									value: item.address_id,
									label: item.addressname
								}

							})
						}

					})
				}
			},
			provinceVal(value) {
				this.inquires.parentID = value;
				this.inquires.level = 2;
				this.locationdata().then(function(res) {
					this.form.site.city.data = res.body.entity.map(function(item) {
						return {
							value: item.address_id,
							label: item.addressname
						}
					})

					this.form.site.city.value = this.form.site.city.data[0].value;
					this.city(this.form.site.city.data[0].value);
				});

			},
			//市
			city(value) {

				this.inquires.parentID = value;
				this.inquires.level = 3;

				this.locationdata().then(function(res) {
					this.form.site.district.data = res.body.entity.map(function(item) {
						return {
							value: item.address_id,
							label: item.addressname
						}
					})
					this.form.site.district.value = this.form.site.district.data[0].value

				})
			},
			//			规模data
			scaledata() {
				this.$http.get(this.$api + '/baseData/getUnitSizeTypeList').then(res => {
					if(res.body.result === 1) {
						this.scaleData = res.body.entity.map((item, index) => {
							return {
								value: item.unitsizetypeId,
								label: item.personnum
							}
						})
					}

				})
			},
			amplificationImg(url) {
				this.$alert('<img src=' + '/UploadImages/' + url + '></img>', {
					showConfirmButton: false,
					dangerouslyUseHTMLString: true,
					customClass: 'imgalert'
				});
			},
			homecourt() {
				this.searchingShow = true;
				this.informationShow = false;
			},
			homecourt2() {
				this.searchingShow = false;
				this.informationShow = true;
			},
		}
	}
</script>
<style lang="scss">
	.perfect {
		padding: 0 0 116px 0;
		text-align: center;
		text-align: left;
		.formbox {
			padding: 0 20px;
			width: 100%;
			.context-fl {
				width: 60%;
			}
			.f-fr {
				width: 40%;
			}
		}
	}
	
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}
	
	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}
	
	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}
	
	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
	
	.searching {
		width: 500px;
		margin: 0 auto;
		margin-top: 10%;
		padding: 20px 0;
		.tit {
			font-size: 15px;
			padding: 10px 0;
			font-weight: 500;
			color: #333333;
			text-align: center;
		}
		.token-box {
			margin-top: 20px;
		}
		.gist {
			.assist {
				font-size: 14px;
				color: #333333;
				margin-left: 10px;
			}
		}
	}
	
	.extend {
		padding: 20px 0;
		width: 60%;
	}
	
	.imgalert {
		width: 40%;
		height: auto;
		text-align: center;
		p {
			height: 100%;
			img {
				width: 100%;
				display: inline-block;
			}
		}
	}
	
	.datahint {
		padding-left: 20px;
	}
	
	.custom-label {
		&::before {
			content: '*';
			color: #F56C6C;
			margin-right: 4px;
		}
	}
</style>